<template>
  <div>
    <Swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="(banner,index) in bannersList" :key="index">
        <a :href="banner.action" target="_blank">
          <img :src="banner.url" :alt="banner.id" class="slide_img">
        </a>
      </swiper-slide>
    </Swiper>
    <div class="banner_tool">
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="banner_btn">
        <div class="swiper-button-prev">
          <img src="@/assets/images/clients/icon_arrow.svg" alt="arrow">
        </div>
        <div class="swiper-button-next">
          <img src="@/assets/images/clients/icon_arrow.svg" alt="arrow">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.min.css'

export default {
  name: 'CourseListBanner',
  props: {
    bannersList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/clients.scss";

.swiper-container {
  width: 100%;
  margin-bottom: 20px;
}

.swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
  >>> .slide_img {
    border-radius: 10px;
  }
}
.swiper-button-prev,.swiper-button-next,.swiper-pagination {
  position: static;
}
.swiper-button-prev,.swiper-button-next {
  margin-top: 0;
  outline:none;
  width: 40px;
  height: 40px;
  background-color: white;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 50%;
  z-index: 2;
  &::after {
    content: ''
  }
}

.banner_tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .banner_btn {
    display: flex;
  }
}
.swiper-button-prev {
  transform: rotate(180deg);
  margin-right: 8px;
}

.swiper-pagination {
  z-index: 2;
  >>> .swiper-pagination-bullet {
    margin: 0 4px;
  }
  >>> .swiper-pagination-bullet-active {
    background: $main_color;
  }
}

@media screen and (min-width: 576px){
  .banner_tool {
    justify-content: flex-end;
    .banner_btn {
      margin-left: 24px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/clients/ClientsCourseList/components/CourseListBanner.vue